module.exports = __webpack_public_path__ + "static/media/GuessMahjong.3bf09429.jpg";